// Normaliza texto para COMPARAR (no para mostrar): sin acentos, en minúsculas, con los
// separadores (-_.) tratados como espacio y los espacios colapsados.
//
// Es lo que permite que "Falta CMO / dictamen", "falta cmo / dictamen" y "Falta CMO/dictamen"
// se reconozcan como lo mismo al buscar en un catálogo o al detectar duplicados — el mismo
// criterio tolerante a tipeo que pide CLAUDE.md para las búsquedas.
export function normalizarParaComparar(texto) {
    return (texto || '')
        .normalize('NFD').replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[-_.]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
}

/**
 * Si una fila entra en un filtro de texto libre: la búsqueda de los listados.
 *
 * Es el criterio que pide CLAUDE.md para TODAS las búsquedas, aplicado del lado del navegador
 * (los listados que ya traen todo y filtran en memoria: turnos, catálogos, etc.):
 *   - sin tildes y en minúsculas: "perez" encuentra "PÉREZ" y "Pérez" encuentra "PEREZ";
 *   - por palabras: cada palabra tiene que aparecer, en cualquier orden. "juan perez" encuentra
 *     "PEREZ, JUAN".
 *
 * `campos` puede ser un texto o una lista de valores (los null/undefined se ignoran), así cada
 * pantalla declara en qué columnas busca sin tener que armar el string a mano.
 *
 * Consulta vacía = no filtra.
 */
export function coincideBusqueda(campos, consulta) {
    const palabras = normalizarParaComparar(consulta).split(' ').filter(Boolean);
    if (palabras.length === 0) return true;
    const texto = normalizarParaComparar(
        Array.isArray(campos) ? campos.filter((c) => c !== null && c !== undefined).join(' ') : campos
    );
    return palabras.every((palabra) => texto.includes(palabra));
}

export default normalizarParaComparar;
